import React from 'react';
import moment from 'moment/moment';
import styled from 'styled-components';

const Table = styled.table`
	margin: 20px 0;
	font-size: 1.4em;
	color: #707070;
	
	thead {
	 color: #B2B2B2;
	 
	 th {
	   border: 0;
	 }
	}
	
	th i {
	 	font-size: 1.6em;
    	margin-right: 7px;
	}
	
	th, td {
	   vertical-align: middle;
	}
	
	tr td {

	 button.btn-danger {
	     background-color: #FF003C;
	     border-color: #FF003C;
	     font-size: 1em;
	     padding: 8px 20px;
	     
	     &:hover {
	       background: #ffffff;
	       color: #FF003C;
	     }
	 }
	 
	 button.btn-simple {
	     background-color: #707070;
	     border-color: #707070;
	     font-size: 1em;
	     padding: 8px 20px;
	     color: #ffffff;
	     
	     &:hover {
	       background: #ffffff;
	       color: #707070;
	     }
	 }
	}	
`;

const btnClickAction = (e, button, row) => {
	if (typeof button.onClick === 'function') {
		button.onClick(row);
	}
};

const renderThead = (tbody, thead) => {
	if (tbody.length === 0) {
		return 'Nenhum briefing disponível.';
	}
	return (
		<tr>
			{ thead.map(data => (
				<th scope="col">{ data }</th>
			))}
		</tr>
	);
};

const TableList = (props) => {
	const {
		dataThead, dataTbody, button, loading, listStatus,
	} = props;

	function textDefault() {
		return (
			<span className="pl-1">- - - -</span>
		);
	}

	function briefingStatus(filteredStatus) {
		let status = 'Briefing não preenchido';

		if (filteredStatus[0]) {
			status = filteredStatus[0].title;
		}

		return status;
	}

	return (
		<div className="table-responsive">
			<Table className="table">
				<thead>
					{ loading ? 'Carregando briefings...' : renderThead(dataTbody, dataThead)}
				</thead>
				<tbody>
					{
						dataTbody.map((briefing) => {
							const filteredStatus = listStatus.filter(
								value => parseInt(value.id, 10) === briefing.demand_status,
							);
							return (
								<tr key={briefing.id ? briefing.id : Math.random()}>
									<td>{briefing.customer_name ? briefing.customer_name : textDefault()}</td>
									<td>{briefing.cnpj ? briefing.cnpj : textDefault()}</td>
									<td>{briefing.pre_sale_id ? briefing.pre_sale_id : textDefault()}</td>
									<td>{briefing.pre_sale_date ? (moment(briefing.pre_sale_date).format('DD/MM/YYYY')) : textDefault()}</td>
									<td>{ briefingStatus(filteredStatus) }</td>
									<td>
										<button type="button" onClick={e => btnClickAction(e, button, briefing)} className={`btn ${button.classButton} float-right`}>{button.value}</button>
									</td>
								</tr>
							);
						})
					}
				</tbody>
			</Table>
		</div>
	);
};

export default TableList;
